import { memo } from 'react'
import styled from 'styled-components'
import { SystemIcon, RowBackToHub, NoData } from 'components'

function TableBackToHub({
  data,
  handleClickDetail,
  handleClickTrack,
  handleClickChangeDriver,
  isFromSuper,
}) {
  return (
    <>
      <Container>
        <thead>
          <Tr>
            <Th>
              DRIVER NAME
              <SystemIcon iconName="up-and-down" fontSize="smallest" className="ml-3" />
            </Th>
            <Th>
              TIMER DRIVER
              <SystemIcon iconName="up-and-down" fontSize="smallest" className="ml-3" />
            </Th>
            <Th>
              WAKTU PESANAN SAMPAI
              <SystemIcon iconName="up-and-down" fontSize="smallest" className="ml-3" />
            </Th>
            <Th>
              ESTIMASI KEMBALI KE HUB
              <SystemIcon iconName="up-and-down" fontSize="smallest" className="ml-3" />
            </Th>
            <Th>
              ORDER ID
              <SystemIcon iconName="up-and-down" fontSize="smallest" className="ml-3" />
            </Th>
            {/* <Th>AKSI</Th> */}
          </Tr>
        </thead>
        <tbody>
          {data.map((el) => (
            <RowBackToHub
              key={el.order_id}
              data={el}
              handleClickChangeDriver={handleClickChangeDriver}
              handleClickDetail={handleClickDetail}
              handleClickTrack={handleClickTrack}
              isFromSuper={isFromSuper}
            />
          ))}
        </tbody>
      </Container>
      {data.length === 0 && <NoData />}
    </>
  )
}

TableBackToHub.defaultProps = {
  data: [],
}

export default memo(TableBackToHub)

const Container = styled.table`
  width: 100%;
  border-collapse: collapse;
  height: fit-content;
`
const Tr = styled.tr`
  background-color: ${({ theme: { colors } }) => colors.tableHead};
`
const Th = styled.th`
  color: ${({ theme: { colors } }) => colors.grey};
  font-size: ${({ theme: { fontSizes } }) => fontSizes.smaller};
  text-align: start;
  padding: 16px 32px;
`
